<div class="grid-row">
  <div class="grid-col-12" [ngClass]="isOrganTransplantType ? 'padding-bottom-2' : 'padding-bottom-4'">
    <label for="filter-by-name-field" class="usa-label custom-label margin-top-0 filter-by-name"
      >Filter by Center Name
    </label>
    <input
      aria-label="Enter a full or partial name"
      placeholder="Enter a full or partial name"
      id="filter-by-name-field"
      type="search"
      class="usa-input maxw-full height-5 margin-top-1 border-1px radius-md"
      #ctrl="ngModel"
      [(ngModel)]="filterByName"
      (ngModelChange)="handleFilterBy($event)"
    />
  </div>

  @if (isOrganTransplantType) {
    <div class="usa-accordion padding-bottom-4">
      <h4 class="usa-accordion__heading">
        <button
          type="button"
          class="usa-accordion__button"
          aria-expanded="false"
          aria-controls="organ-selection"
        >
          Filter By Organ:
        </button>
      </h4>
      <div
        id="organ-selection"
        class="usa-accordion__content border-1px border-base margin-top-1"
        hidden
      >
        <form [formGroup]="organTransplantFormGroup">
          <div class="grid-row display-flex flex-align-center">
            <input
              type="checkbox"
              id="all"
              value="All Transplant Programs"
              formControlName="all"
              (change)="handleCheckboxClick('all')"
            />
            <label class="font-ui-sm" for="all">All Transplant Programs</label>
          </div>

          @for (programType of programTypes; track programType; let i = $index) {
            <div class="grid-row display-flex flex-align-center">
              <input
                type="checkbox"
                [id]="'otp' + programType.Id"
                [formControlName]="'otp' + programType.Id"
                (change)="handleCheckboxClick('otp' + programType.Id)"
              />
              <label class="font-ui-sm" [for]="'otp' + programType.Id">{{ programType.ServiceType }}</label>
            </div>
          }
        </form>
      </div>
    </div>
  }
</div>
